export default __webpack_public_path__ + "0609599.png";